import getURLDetails from "./endPoints";
import HTTP from "./httpServices";
import { KEYS, SERVER_ERROR_MESSAGES } from "../utils/constants";
import { store } from "../store";
import { session } from "../actions/Login/action";
import {
  setRecommendedApiError,
  showApiResponseError,
  showMemberApiError,
} from "../actions/Home/action";
import { AuthSingleton } from "../utils/AuthSingleton";
import { IONICWrapper } from "../utils/common";
import { showBuyLoadError } from "../actions/Search/action";
import { recordException } from "../utils/Crashlytics";

/**
 * This common service is used to make GET and POST Web API calls.
 */

const serviceRequests = {};
let hasSession = true;
 /*
   * To get the error message based on the API status code
   * @status - API response status
   */
  const getErrorMessage = (status: number,message?:string) => {
    let _message = "";
    switch (status) {
      case 401:
        _message = SERVER_ERROR_MESSAGES.unAuthorizedMsg;
        break;
      default:
        if(!!message) _message = message;
        else _message = SERVER_ERROR_MESSAGES.serverErrorMsg;
        break;
    }
    return _message;
  }
  /**
   * To fetch data from the Web Service API.
   * @param {string} endPoint end point value.
   * @param {string} urlKey url key value.
   * @param {*} data request data to be transfered.
   * @param {*} token token value.
   * @param {*} responseType response type.
   * @param {*} serviceProgress callback for monitoring service progress.
   * @returns {promise} result of the Service API.
   */

  export const get = (
    endPoint: string,
    urlKey: string,
    data?: any,
    token?: string,
    responseType?: string,
    serviceProgress?: Function
  ) => {
    const _endPointEntity = getURLDetails(endPoint, urlKey, data);
    return new Promise(function (resolve: any, reject: any) {
      getHeaders(endPoint, responseType).then((headers: any) => {
        if (_endPointEntity) {
          new HTTP()
            .__request(
              _endPointEntity.get_Service_Url(),
              headers,
              "get",
              null,
              urlKey,
              serviceRequests,
              function (pgr: any) {
                serviceProgress && serviceProgress(pgr);
              }
            )
            .then((response: any) => {

              if (response && response.status >= 200 && response.status < 300) {
                resolve(response.data);
              } else {
                const message = getErrorMessage(response.status);
                reject(new Error(message));
              }
            })
            .catch((error: any) => {
              if (endPoint !== "AZURE_SERVICES") {
                const message = getErrorMessage(
                  error && error.response && error.response.status,
                  error?.response?.data?.message
                );
                store.dispatch(showApiResponseError({ message }));
              }
              reject(error);
            });
        } else {
          reject("No URL is provided for Service Request");
        }
      });
    });
  }

  /**
   * To post data to the Web Service API.
   * if there is no specic functional programming is designated for the post API, the above GET methods will be changed to single common metohd in future based on the excersize.
   * @param {string} endPoint end_point.
   * @param {string} urlKey url key value.
   * @param {*} data request data to be transfered.
   * @param {*} token token value.
   * @param {*} responseType response type.
   * @param {*} serviceProgress callback for monitoring service progress.
   * @returns {promise} result of the Service API.
   */

  export const post = (
    endPoint: string,
    urlKey: string,
    data: any,
    token?: string,
    requestData?: any,
    responseType?: any,
    serviceProgress?: any
  ) => {
    const _endPointEntity = getURLDetails(endPoint, urlKey, data);
    const _dataString = requestData;
    return new Promise(function (resolve: any, reject: any) {
      getHeaders(endPoint, responseType).then((headers: any) => {
        if (_endPointEntity && headers) {
          new HTTP()
            .__request(
              _endPointEntity.get_Service_Url(),
              headers,
              "post",
              _dataString,
              urlKey,
              serviceRequests,
              function (pgr: any) {
                serviceProgress && serviceProgress(pgr);
              }
            )
            .then((response) => {
              if (response && response.status >= 200 && response.status < 300) {
                resolve(response.data);
              } else {
                const message = getErrorMessage(response.status);
                reject(new Error(message));
              }
            })
            .catch((error) => {
              const message = getErrorMessage(
                error && error.response && error.response.status,
                error?.response?.data?.message
              );
              if (error && error.response) {
                recordException({
                  message: message || "",
                  code: error.response.status || "",
                  domain: error.response.url || "",
                });
              }

              if (urlKey === "GET_USER_DETAILS") {
                store.dispatch(showMemberApiError(true));
              } else {
                if (message === "" && urlKey === "BUY_LOAD") {
                  const status =
                    error && error.response && error.response.status;
                  if (
                    !status ||
                    status === 202 ||
                    status === "error" ||
                    status === "UNKNOWN"
                  ) {
                    store.dispatch(showBuyLoadError(true));
                  }
                } else if (urlKey === 'RECOMMENDED_LOADS') {
                  store.dispatch(setRecommendedApiError(true));
                } else {
                  store.dispatch(showApiResponseError({ message }));
                }
              }
              reject(error);
            });
        } else {
          reject("No URL is provided for Service Request");
        }
      });
    });
  }
  /**
   * To update/PUT data to the Web Service API.
   * if there is no specic functional programming is designated for the post API, the above GET methods will be changed to single common metohd in future based on the excersize.
   * @param {string} endPoint end_point.
   * @param {string} urlKey url key value.
   * @param {*} data request data to be transfered.
   * @param {*} token token value.
   * @param {*} responseType response type.
   * @param {*} serviceProgress callback for monitoring service progress.
   * @returns {promise} result of the Service API.
   */

  export const put = (
    endPoint: string,
    urlKey: string,
    data: any,
    token?: string,
    requestData?: any,
    responseType?: any,
    serviceProgress?: any
  ) => {
    const _endPointEntity = getURLDetails(endPoint, urlKey, data);
    const _dataString = requestData;
    return new Promise(function (resolve: any, reject: any) {
      getHeaders(endPoint, responseType).then((headers: any) => {
        if (_endPointEntity && headers) {
          new HTTP()
            .__request(
              _endPointEntity.get_Service_Url(),
              headers,
              "put",
              _dataString,
              urlKey,
              serviceRequests,
              function (pgr: any) {
                serviceProgress && serviceProgress(pgr);
              }
            )
            .then((response) => {
              if (response && response.status >= 200 && response.status < 300) {
                resolve(response.data);
              } else {
                const message = getErrorMessage(response.status);
                reject(new Error(message));
              }
            })
            .catch((error) => {
              const message = getErrorMessage(
                error && error.response && error.response.status,
                error?.response?.data?.message
              );
              reject(error);
            });
        } else {
          reject("No URL is provided for Service Request");
        }
      });
    });
  }
  /**
   * To get Headers information for the specified servcie API.
   * @param {*} endPoint API end point.
   * @param {*} responseType response type.
   * @returns {object} consolidated header list.
   */
  const getHeaders = async (endPoint?: string, responseType?: string) => {
 //Redirecting to the landing screen when session is expired.
    const auth = AuthSingleton.getInstance();
    const SUBSCRIPTION_KEY =
      endPoint !== "NOTIFICATION_SERVICES"
        ? KEYS.SUBSCRIPTION_KEY
        : KEYS.NOTIFICATION_SUBSCRIPTION_KEY
    if (hasSession) {
      hasSession = false;
      const isActiveSession = auth && (await auth.isAuthenticated());
      hasSession = true;
      if (!isActiveSession) {
        store.dispatch(session(Math.floor(Math.random() * 100)));
        return null;
      }
    }
    const token = await auth.getAuthResponse() && (await auth.getAuthResponse()).id_token;

    const headers: any = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "-1",
      "X-XSS-Protection": "1; mode=block",
      "X-Frame-Options": "SAMEORIGIN",
      "Content-Security-Policy": "script-src 'self'",
      "X-Content-Type-Options": "nosniff",
      Allow: "GET, POST, HEAD",
      // "Content-Encoding": "deflate, gzip",
      "Transfer-Encoding": "compress",
      "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
    };

    if (token) {
      headers["Authorization"] = "Bearer " + token;
    } else {
      return null;
    }

    return headers;
  }

  /**
   * To cancel request
   * @param {string} endPointKey response type.
   */
  const cancelRequest = (endPointKey: string) => {
    const currentReqest = JSON.parse(JSON.stringify(serviceRequests))[
      endPointKey
    ];
    currentReqest.cancel(
      endPointKey + " Service Request has been cancelled by Agent"
    );
  }

  /**
   * To set minTime for request depature
   * @returns {number} minTime for request depature.
   */
  export const set_depMinTime = () => {
    const depMinTime = 1;
    const depMinTimeConfig =
      IONICWrapper.details.keys &&
      parseInt(IONICWrapper.details.keys.configuration.depMinTime);
    return depMinTimeConfig || depMinTime;
  }

  export const set_depMaxTime = () => {
    const depMaxTime = 60;
    const depMaxTimeConfig =
      IONICWrapper.details.keys &&
      parseInt(IONICWrapper.details.keys.configuration.depMaxTime);
    return depMaxTimeConfig || depMaxTime;
  }
